import { fetchOpenAIText } from "../utils/openaiClient";

export function useLeadInActivitiesGeneratorLogic({
  leadInActivitiesInput, setLeadInActivitiesInput, leadInActivitiesLevel,
  setLeadInActivitiesLoading, generatedLeadInActivities, setGeneratedLeadInActivities,
  currentTab, onInsertToBoard, activeEditor,
  setShowLeadInActivitiesGenerator, setSelectedTemplate,
}) {
  const handleLeadInActivitiesGenerate = async () => {
    if (!leadInActivitiesInput.trim()) return;

    // Проверяем длину текста и предупреждаем пользователя
    const textLength = leadInActivitiesInput.length;
    if (textLength > 2000) {
      const confirmGenerate = window.confirm(
        `Текст довольно длинный (${textLength} символов). Генерация может занять больше времени. Продолжить?`
      );
      if (!confirmGenerate) return;
    }

    setLeadInActivitiesLoading(true);
    try {
      const levelDescriptions = {
        'A1': 'Beginner - Simple vocabulary, basic grammar, short sentences, visual aids',
        'A2': 'Elementary - Common vocabulary, present/past tenses, everyday topics',
        'B1': 'Intermediate - Complex vocabulary, various tenses, abstract concepts',
        'B2': 'Upper Intermediate - Advanced vocabulary, complex grammar, nuanced topics',
        'C1': 'Advanced - Sophisticated language, complex ideas, critical thinking',
        'C2': 'Mastery - Native-like proficiency, complex texts, academic language'
      };

      const prompt = `Create 4 lead-in activities for the following text. These activities should prepare students for reading the text and activate their prior knowledge.

LEVEL: ${leadInActivitiesLevel} - ${levelDescriptions[leadInActivitiesLevel]}

For ${leadInActivitiesLevel} level students, create activities that:
- Use appropriate vocabulary complexity
- Match the grammatical structures students know
- Include clear, step-by-step instructions
- Provide scaffolding for success
- Are engaging and age-appropriate

IMPORTANT: Return ONLY valid JSON in this exact format:
{
  "title": "Lead-in Activities",
  "level": "${leadInActivitiesLevel}",
  "text": "${leadInActivitiesInput}",
  "activities": [
    {
      "title": "Activity title here",
      "description": "Detailed step-by-step instructions for the activity",
      "type": "vocabulary|prediction|discussion|brainstorming|visual|kinesthetic|collaborative",
      "duration": "5-10 minutes",
      "materials": "List of required materials",
      "instructions": [
        "Step 1: Clear instruction",
        "Step 2: Next step",
        "Step 3: Final step"
      ],
      "expectedOutcome": "What students should achieve"
    }
  ]
}

Text: ${leadInActivitiesInput}`;



      const content = await fetchOpenAIText({
        prompt,
        temperature: 0.7,
        maxTokens: 3000,
      });

      if (content) {
        try {
          let contentStr = content.trim();
          // Удаляем markdown-блоки, если есть
          if (contentStr.startsWith('```json')) {
            contentStr = contentStr.replace(/^```json\n/, '').replace(/\n```$/, '');
          } else if (contentStr.startsWith('```')) {
            contentStr = contentStr.replace(/^```\n/, '').replace(/\n```$/, '');
          }

          // Парсим JSON напрямую без предварительной обработки
          const parsed = JSON.parse(contentStr);

          if (parsed.activities && Array.isArray(parsed.activities)) {
            setGeneratedLeadInActivities(parsed);
          } else {
            // Invalid Lead-in Activities exercise format
          }
        } catch (parseError) {
          // Проверяем, не обрезан ли ответ из-за лимита токенов
          if (content && !content.includes('"expectedOutcome"')) {
            alert('Ответ был обрезан из-за длины. Попробуйте сократить текст или попробуйте снова.');
          } else {
            alert('Ошибка парсинга JSON. Попробуйте снова.');
          }
        }
      }
    } catch (e) {
      // Error in handleLeadInActivitiesGenerate
    } finally {
      setLeadInActivitiesLoading(false);
    }
  };

  const handleLeadInActivitiesInsert = () => {
    if (!generatedLeadInActivities) return;
    if (currentTab > 0 && onInsertToBoard) {
      onInsertToBoard(generatedLeadInActivities, 'leadinactivities');
      setShowLeadInActivitiesGenerator(false);
      setLeadInActivitiesInput("");
      setSelectedTemplate(null);
      return;
    }
    if (!activeEditor) return;
    activeEditor.chain().focus().insertLeadInActivitiesExercise({
      text: generatedLeadInActivities.text,
      activities: generatedLeadInActivities.activities,
      title: generatedLeadInActivities.title,
      level: generatedLeadInActivities.level
    }).run();

    setShowLeadInActivitiesGenerator(false);
    setLeadInActivitiesInput("");
    setSelectedTemplate(null);
  };

  const handleLeadInActivitiesCancel = () => {
    setShowLeadInActivitiesGenerator(false);
    setLeadInActivitiesInput("");
    setGeneratedLeadInActivities(null);
    setSelectedTemplate(null);
  };

  return { handleLeadInActivitiesGenerate, handleLeadInActivitiesInsert, handleLeadInActivitiesCancel };
}
